import OwnPublicationImage from './OwnPublicationImage';


export default OwnPublicationImage;
